var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"d-flex flex-column flex-sm-row justify-center justify-sm-space-around align-center"},[_c('LocaleSwitcher',{staticClass:"d-inline-flex mr-2 mb-1 mb-sm-0"}),_c('ThemeSwitcher',{staticClass:"d-inline-flex"})],1)}
var staticRenderFns = []

export { render, staticRenderFns }